import { Injectable } from '@angular/core';
import { Course } from '../../models/course';
import { LessonSong } from '../../models/lesson-song'
import { Base } from '../../models/base-model'
import { Song } from '../../models/song'
import { ColumnWidth } from '../../models/column-width'

export interface LessonPrefs {
  tonalityShown: boolean,
  meterShown: boolean,
  swowShown: boolean,
  activityShown: boolean,
  rpShown: boolean,
  tpShown: boolean,
  instrumentShown: boolean,
  recordingShown: boolean,
  pemShown: boolean,
}

@Injectable()
export class PreferencesProvider {

  // if we change the structure, then bump the version num
  expandedCoursesKey = 'expandedCourses.v0'
  expandedLessonSongsKey = 'expandedLessonSongs.v0'
  expandedBowlingSongsKey = 'expandedBowlingSongs'
  lessonPrefsKey = 'lessonPrefs.v0'
  addSongSortOrderKey = 'addSongSortOrder.v0'
  columnSizePrefsKey = 'columnSizePrefs.v0'

  constructor() {
  }

  private isExpanded(base: Base, key: string) {
    const expandedItems = JSON.parse(localStorage.getItem(key)) || []
    return expandedItems.indexOf(base.uuid) >= 0
  }

  private setExpanded(base: Base, expanded: boolean, key: string) {
    const expandedItems = JSON.parse(localStorage.getItem(key)) || []

    if (expanded && !this.isExpanded(base, key)) {
      expandedItems.push(base.uuid)
      localStorage.setItem(key, JSON.stringify(expandedItems))
    }

    if (!expanded && this.isExpanded(base, key)) {
      expandedItems.splice(expandedItems.indexOf(base.uuid), 1)
      localStorage.setItem(key, JSON.stringify(expandedItems))
    }
  }

  isBowlingSongExpanded(song: Song): boolean {
    return this.isExpanded(song, this.expandedBowlingSongsKey)
  }

  setBowlingSongExpanded(song: Song, expanded: boolean) {
    this.setExpanded(song, expanded, this.expandedBowlingSongsKey)
  }

  isLessonSongExpanded(song: LessonSong): boolean {
    return this.isExpanded(song, this.expandedLessonSongsKey)
  }

  setLessonSongExpanded(song: LessonSong, expanded: boolean) {
    this.setExpanded(song, expanded, this.expandedLessonSongsKey)
  }

  isCourseExpanded(course: Course): boolean {
    return this.isExpanded(course, this.expandedCoursesKey)
  }

  setCourseExpanded(course: Course, expanded: boolean) {
    this.setExpanded(course, expanded, this.expandedCoursesKey)
  }

  getLessonPrefs(): LessonPrefs {
    return JSON.parse(localStorage.getItem(this.lessonPrefsKey)) || {
      tonalityShown: true,
      meterShown: true,
      swowShown: true,
      activityShown: true,
      rpShown: true,
      tpShown: true,
      instrumentShown: true,
      recordingShown: true,
      pemShown: true,
    }
  }

  setLessonPrefs(prefs: LessonPrefs) {
    localStorage.setItem(this.lessonPrefsKey, JSON.stringify(prefs))
  }

  setAddSongSortOrder(order: string) {
    localStorage.setItem(this.addSongSortOrderKey, order)
  }

  getAddSongSortOrderPref(): string {
    return localStorage.getItem(this.addSongSortOrderKey)
  }

  setColumnSizePref(columnWidths: ColumnWidth[]) {
    localStorage.setItem(this.columnSizePrefsKey, JSON.stringify(columnWidths.map((column: ColumnWidth) => {
      return {name: column.name, width: column.width}
    })))
  }

  getColumnSizePrefs(): any[] {
    return JSON.parse(localStorage.getItem(this.columnSizePrefsKey)) || [
      {name: 'name', width: 200},
      {name: 'tonality', width: 100},
      {name: 'meter', width: 60},
      {name: 'swow', width: 60},
      {name: 'activity', width: 175},
      {name: 'rp', width: 40},
      {name: 'tp', width: 40},
      {name: 'instrument', width: 75},
      {name: 'recording', width: 100},
      {name: 'pem', width: 140},
      {name: 'info', width: 34},
    ]
  }

}
